<template>
	<div class="ph">
		<div class="ph__elm">
			<!-- /////////////////// -->
			<!-- Payment history -->
			<div
				class="ph__elm-row"
				v-for="(item, idx) in payHistory"
				:key="idx"
			>
				<div class="ph__elm-row-icon">
					<!-- BALANCE -->
					<div v-if="item.type === 0">
						<IconPlus />
					</div>

					<!-- CHANNEL -->
					<div v-if="item.type === 1">
						<IconArrowLeftDown />
					</div>

					<!-- OPTIONS -->
					<div v-if="item.type === 3">
						<IconPlus />
					</div>
				</div>
				<div class="ph__elm-row-message">
					<div class="ph__elm-row-message_text">
						<!-- BALANCE -->
						<template v-if="item.type === 0">
							<div>
								{{
									0 < item.cost
										? "Пополнение баланса"
										: "Списание с баланса"
								}}
							</div>

							<div class="ph__elm-row-cost">
								{{ item.amount * item.cost }} ₽
							</div>
						</template>

						<template v-else-if="item.type === 1">
							<!-- CHANNEL -->
							<div>
								{{ item.amount }} {{ declOfNum(item.amount) }}
							</div>
						</template>

						<template v-else-if="item.type === 3">
							<!-- OPTIONS -->
							<div>Покупка опций</div>
						</template>
					</div>
				</div>
				<div class="ph__elm-row-period">
					<div class="ph__elm-row-period-active">
						{{ 0 < item.cost ? "Дата покупки" : "Дата списания" }}
					</div>
					<div class="ph__elm-row-period-month">
						{{ dataTimeFormat(item.paidStamp) }}
					</div>
				</div>
				<div class="ph__elm-row-period-m">
					<div class="ph__elm-row-period-m-month">
						{{ dataTimeFormat(item.paidStamp) }}
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import IconPlus from "@/components/icons/IconPlus.vue";
import IconArrowLeftDown from "@/components/icons/IconArrowLeftDown.vue";
import { mapActions, mapGetters } from "vuex";
import dayjs from "dayjs";
import "dayjs/locale/ru";
dayjs.locale("ru");

@Options({
	components: { IconPlus, IconArrowLeftDown },

	computed: {
		...mapGetters("paymentModule", {
			payHistory: "payHistoryGetters",
		}),
	},

	methods: {
		...mapActions("paymentModule", ["payHistoryAction"]),
	},
})
export default class PaymentHistory extends Vue {
	// ************************************************************
	// Define mapGetters
	public payHistory: Array<{
		type: number;
		cost: number;
		amount: number;
		paidStamp: number;
	}>;

	// ************************************************************
	// Define mapActions
	public payHistoryAction!: () => Promise<void>;

	/**
	 * Hook mounted
	 */
	public async mounted() {
		await this.payHistoryAction();
	}

	/**
	 * Форматируем timestamp к виду - 15 августа 10:00
	 * @param timestamp
	 */
	public dataTimeFormat(timestamp: number) {
		return dayjs(timestamp).format("DD MMMM HH:mm");
	}

	/**
	 * Склонение по числу для слова - канал
	 * @param n
	 * @param titles
	 */
	public declOfNum(n: number, titles = ["канал", "канала", "каналов"]) {
		return titles[
			n % 10 === 1 && n % 100 !== 11
				? 0
				: n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20)
				? 1
				: 2
		];
	}
}
</script>

<style scoped lang="scss">
.ph {
	&__elm {
		display: flex;
		flex-direction: column;
	}

	&__elm-row {
		display: grid;
		grid-template-columns: 50px 1fr 1fr;
		gap: 2px;
		padding: 18px;
		margin-top: 2px;
		align-items: center;
		background: rgb(252, 252, 252);
	}

	&__elm-row:first-child {
		border-top-left-radius: 12px;
		border-top-right-radius: 12px;
	}

	&__elm-row:last-child {
		border-bottom-left-radius: 12px;
		border-bottom-right-radius: 12px;
		box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.02);
	}

	&__elm-row-message {
		display: flex;
		flex-direction: column;
	}

	&__elm-row-icon {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 28px;
		height: 28px;
		background: rgb(244, 246, 250);
		border-radius: 50%;
	}

	&__elm-row-message_text {
		font-size: 16px;
		color: rgb(49, 49, 50);
	}

	&__elm-row-message_date {
		font-size: 14px;
		color: rgb(119, 121, 124);
	}

	&__elm-row-period {
		font-size: 16px;
		color: rgb(49, 49, 50);
	}

	&__elm-row-period-m {
		font-size: 16px;
		color: rgb(49, 49, 50);
	}

	&__elm-row-period-active {
		color: rgb(49, 49, 50);
	}

	&__elm-row-period-m-active {
		color: rgb(49, 49, 50);
	}

	&__elm-row-period-month {
		display: flex;
		color: rgb(119, 121, 124);
		font-size: 14px;
	}

	&__elm-row-period-m-month {
		display: flex;
		color: rgb(119, 121, 124);
		font-size: 14px;
		flex-direction: column;
	}

	&__elm-row-period-month_green {
		color: rgb(0, 210, 55);
		font-size: 14px;
		margin-left: 6px;
	}

	&__elm-row-period-m-month_green {
		color: rgb(0, 210, 55);
		font-size: 14px;
		padding: 2px 0;
	}

	&__elm-row-cost {
		display: inline-flex;
		font-size: 16px;
		color: rgb(199 199 199);
	}

	@media screen and (max-width: 768px) {
		&__elm-row-period {
			display: none;
		}

		&__elm-row-period-active {
			display: none;
		}
	}

	@media screen and (min-width: 768px) {
		&__elm-row-period-m {
			display: none;
		}
	}
}
</style>
